import { Colors } from "src/com/sixdee/crbtportal/utils/resources/colors";
import { Fonts } from "src/com/sixdee/crbtportal/utils/resources/fonts";
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../../uicomponentcss";


export interface PasswordTextCSSStyle extends UIComponentCSSStyle
{
    getTextCSSStyle(isFloatingLabel: boolean): object;
    getErrorCSSStyle(): object;
    getErrorTextDivCSSStyle(): object;
    getPasswordDivCSSStyle():object;
    getEyeIconCSSStyle():object;
    getErrorTextCSSStyle(language:any): object;
}

export class PasswordTextCSSStyleImpl extends UIComponentCSSStyleImpl implements PasswordTextCSSStyle
{
    getWrapperCSSStyle(): object 
    {
        return {
            display: "flex",
            position: "relative",
            flexDirection: "column",
            marginTop: "30px",
        };
    }

    getPasswordDivCSSStyle():object
    {
        return{
             width:"100%",
             display:"flex",
             borderBottom: "1px solid " + this.getResources().getColor(Colors.color_39),
             outline: "none",
        };
    }

    getEyeIconCSSStyle():object
    {
        return{
            width:"20px",height:"20px",
            cursor:"pointer"
        };
    }
    getTextCSSStyle(isFloatingLabel: boolean): object 
    {
        console.log("isFloatingLabel: " + isFloatingLabel);
        if(isFloatingLabel)
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                width: "95%",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_5),
                borderLeft:0,
                outline: "none",
                fontFamily: this.getResources().getFontFamily()

            };
        }
        else
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                width: "95%",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_5),
                borderLeft:0,
                outline: "none",
                fontFamily: this.getResources().getFontFamily()

            };
        }
    }
    getErrorCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h9),
            color: this.getResources().getColor(Colors.color_4),
            height: "30px",
            bottom: "3px",
            textDecoration: "none",
            borderTop: 0,
            borderRight:0,
            fontWeight: 500,
            borderBottom: "2px solid " + this.getResources().getColor(Colors.color_11),
            borderLeft:0,
            outline: "none",
            fontFamily: this.getResources().getFontFamily()

        };
    }

    getErrorTextDivCSSStyle(): object 
    {
        return {
           display: "flex",
        
        };
    }

    getErrorTextCSSStyle(language:any): object {
        return {
            color: this.getResources().getColor(Colors.color_12),
            fontSize: this.getResources().getFont(Fonts.h5),
            margin:'3px 0px 0px auto',
            height:'auto',
            fontFamily:this.getResources().getFontFamily()

        };
    } 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/password/passwordtextcss.tsx